import type { WorkSpace } from 'features/workspace'

const format = (time: [number, number]) =>
	time.map(n => n.toString().padStart(2, '0')).join(':')

const getTime = (allMinutes: number): [number, number] => {
	const hours = Math.floor(allMinutes / 60)
	const minutes = allMinutes % 60
	return [hours, minutes]
}

const getHoursInterval = ({ duration, start }: WorkSpace.Day) =>
	[start, start + duration].map(getTime).map(format).join('-')

export { getHoursInterval }
